import { ConversationConfig } from '@/types_cp/agent';

import { MetaData } from '../meta';
import { SessionGroupId } from './session-group';

export enum ConversationType {
  Agent = 'agent',
  Group = 'group',
}

export interface SilverTigerAgentSession {
  config: ConversationConfig;
  createdAt: Date;
  group?: SessionGroupId;
  id: string;
  meta: MetaData;
  pinned?: boolean;
  tags?: string[];
  type: ConversationType.Agent;
  updatedAt: Date;
}

export interface ConversationSetting {
  config: ConversationConfig;
  meta: MetaData;
}

export type SilverTigerSessions = SilverTigerAgentSession[];
